/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { forceNormalizeString } from '../interpreter/ArithmeticHelper';
import { rangeLowerBound } from '../interpreter/binarySearch';
import { getRawValue } from '../interpreter/InterpreterValue';
import { AdvancedFind } from './AdvancedFind';
export class RowSearchStrategy extends AdvancedFind {
    constructor(config, dependencyGraph) {
        super(dependencyGraph);
        this.config = config;
        this.dependencyGraph = dependencyGraph;
    }
    find(key, range, sorted) {
        if (typeof key === 'string') {
            key = forceNormalizeString(key);
        }
        if (range.width() < this.config.binarySearchThreshold || !sorted) {
            const values = this.dependencyGraph.computeListOfValuesInRange(range).map(getRawValue).map(arg => (typeof arg === 'string') ? forceNormalizeString(arg) : arg);
            const index = values.indexOf(key);
            return index < 0 ? index : index + range.start.col;
        }
        else {
            return rangeLowerBound(range, key, this.dependencyGraph, 'col');
        }
    }
}
